import { useEffect, useState } from 'react';
import { ArrowLeft, Loader2 } from 'lucide-react';
import { Link } from 'react-router';
import logo from '@/assets/599ad72d49c8887573a4750887df95ce60e36150.png';
import { settingsService } from '../services/settingsService';

const DISCLOSURE_KEY = 'driver_disclosure_text';

const DEFAULT_DISCLOSURE = `Doğuş Çay ve Gıda Maddeleri Üretim Pazarlama İthalat İhracat A.Ş.

YÜK ORTAĞIM SÜRÜCÜ AYDINLATMA METNİ

Sayın İlgili,
6698 sayılı Kişisel Verilerin Korunması Kanunu ("Kanun") 10'uncu maddesi ile Aydınlatma Yükümlülüğünün Yerine Getirilmesinde Uyulacak Usul ve Esaslar Hakkında Tebliğ uyarınca işbu Aydınlatma Metni hazırlanmıştır. Doğuş Çay ve Gıda Maddeleri Üretim Pazarlama İthalat İhracat A.Ş. ("Doğuş Çay" veya "Şirket"), Platform'un sahibi ve işletmecisi olarak veri sorumlusudur.

Veri Sorumlusunun Kimliği
Ticaret Unvanı: Doğuş Çay ve Gıda Maddeleri Üretim Pazarlama İthalat İhracat A.Ş.
MERSİS / Sicil Numarası: (…)
Adresi: (…)

İlgili Kişi Hakları ve Başvuru
Kanun'un 11'inci maddesi uyarınca haklarınızı kullanabilirsiniz:
a) Kişisel verilerinizin işlenip işlenmediğini öğrenme,
b) Kişisel verileriniz işlenmişse buna ilişkin bilgi talep etme,
c) Kişisel verilerinizin işlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme,
ç) Kişisel verilerinizin yurt içinde veya yurt dışında aktarıldığı üçüncü kişileri bilme,
d) Eksik veya yanlış işlenmiş kişisel verilerinizin düzeltilmesini isteme,
e) Kanun'un 7'nci maddesindeki şartlar çerçevesinde kişisel verilerinizin silinmesini veya yok edilmesini isteme,
f) Düzeltme, silme veya yok etme işlemlerinin kişisel verilerinizin aktarıldığı üçüncü kişilere bildirilmesini isteme,
g) Kişisel verilerinizin münhasıran otomatik sistemler aracılığıyla analiz edilmesi nedeniyle aleyhinize bir sonucun ortaya çıkmasına itiraz etme,
ğ) Kişisel verilerinizin kanuna aykırı işlenmesi nedeniyle zarara uğramanız hâlinde zararın giderilmesini talep etme.

Başvurularınızı, Veri Sorumlusuna Başvuru Usul ve Esasları Hakkında Tebliğ'e uygun olarak iletebilirsiniz. Başvurunuz en geç otuz (30) gün içinde ücretsiz sonuçlandırılır.

Aydınlatma Metni'ni okudum.
`;

export function Disclosure() {
  const [disclosure, setDisclosure] = useState(DEFAULT_DISCLOSURE);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    settingsService
      .getPublicSettingValue<string>(DISCLOSURE_KEY, DEFAULT_DISCLOSURE)
      .then((value) => {
        if (!active) return;
        setDisclosure(String(value || DEFAULT_DISCLOSURE));
      })
      .catch(() => {
        if (!active) return;
        setDisclosure(DEFAULT_DISCLOSURE);
      })
      .finally(() => {
        if (!active) return;
        setLoading(false);
      });
    return () => {
      active = false;
    };
  }, []);

  return (
    <div className="min-h-screen bg-slate-50 py-10 px-4">
      <div className="max-w-5xl mx-auto bg-white rounded-3xl shadow-sm border border-slate-200 p-8 md:p-10 space-y-8">
        <div className="flex items-center justify-between gap-4">
          <Link to="/driver-mobile-auth" className="inline-flex items-center gap-2 rounded-full bg-slate-100 px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-200 transition-colors">
            <ArrowLeft className="w-4 h-4" /> Geri Dön
          </Link>
          <img src={logo} alt="Yük Ortağım Logo" className="h-14 w-auto rounded-2xl border border-slate-200 bg-white p-2 shadow-sm" />
        </div>

        <div>
          <div className="inline-flex items-center rounded-full border border-blue-200 bg-blue-50 px-3 py-1 text-sm font-medium text-blue-800 mb-4">Yük Ortağım</div>
          <h1 className="text-3xl font-bold text-slate-900">Doğuş Çay ve Gıda Maddeleri Üretim Pazarlama İthalat İhracat A.Ş. Yük Ortağım Aydınlatma Metni</h1>
        </div>

        <section className="space-y-5 text-slate-700 leading-7">
          {loading ? (
            <div className="flex items-center gap-3 rounded-2xl border border-slate-200 bg-slate-50 p-5 text-slate-600">
              <Loader2 className="h-5 w-5 animate-spin" /> Aydınlatma metni yükleniyor...
            </div>
          ) : (
            <div className="rounded-2xl border border-slate-200 bg-slate-50 p-6 text-sm leading-7 text-slate-700 whitespace-pre-wrap">
              {disclosure}
            </div>
          )}
        </section>
      </div>
    </div>
  );
}
